module.exports = __webpack_public_path__ + "img/teamwork-icon-1.6e2a3207.png";